"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.approveReply = approveReply;
exports.approveTopic = approveTopic;
exports.assignIdeaStatus = assignIdeaStatus;
exports.assignModerator = assignModerator;
exports.cancelSchedule = cancelSchedule;
exports.changeAuthor = changeAuthor;
exports.createTopic = createTopic;
exports.deletePoll = deletePoll;
exports.deleteTopic = deleteTopic;
exports.editContent = editContent;
exports.editFeaturedImage = editFeaturedImage;
exports.editFeaturedImageAltText = editFeaturedImageAltText;
exports.editModeratorTags = editModeratorTags;
exports.editPollOptions = editPollOptions;
exports.editPollTitle = editPollTitle;
exports.editPost = editPost;
exports.editProductAreas = editProductAreas;
exports.editPublicLabel = editPublicLabel;
exports.editReply = editReply;
exports.editTags = editTags;
exports.editTitle = editTitle;
exports.getContentType = getContentType;
exports.getPrivateId = getPrivateId;
exports.getReplies = getReplies;
exports.getTopic = getTopic;
exports.highlightReply = highlightReply;
exports.isTopicAvailable = isTopicAvailable;
exports.like = like;
exports.likeReply = likeReply;
exports.markTopicAsSpam = markTopicAsSpam;
exports.mergeVotes = mergeVotes;
exports.move = move;
exports.newPost = newPost;
exports.promoteReply = promoteReply;
exports.publish = publish;
exports.replyToTopic = replyToTopic;
exports.resolveReply = resolveReply;
exports.resolveTopic = resolveTopic;
exports.schedule = schedule;
exports.setModerationLabel = setModerationLabel;
exports.toggleClosed = toggleClosed;
exports.toggleReplyTrashed = toggleReplyTrashed;
exports.toggleSticky = toggleSticky;
exports.toggleTrashed = toggleTrashed;
exports.unassignModerator = unassignModerator;
exports.unlike = unlike;
exports.unlikeReply = unlikeReply;
exports.unsetModerationLabel = unsetModerationLabel;
exports.unvote = unvote;
exports.vote = vote;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _qs = _interopRequireDefault(require("qs"));

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var _insidedDataStorage = require("../utils/insidedDataStorage");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function newPost(topicId, type) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(content) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return replyToTopic(type, topicId, content);

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function editPost(topicId, replyId, type) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(content) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return editReply(type, replyId, content);

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function createContentEndpoint(contentType) {
  switch (contentType) {
    case 'question':
      return '/community/api/questions/ask';

    case 'idea':
      return '/community/api/ideas/submit';

    case 'conversation':
      return '/community/api/conversations/start';

    default:
      return "/community/api/".concat(contentType, "s/create");
    // article and product update
  }
}

function createTopic(_x3, _x4, _x5, _x6, _x7, _x8, _x9, _x10, _x11, _x12, _x13, _x14, _x15, _x16) {
  return _createTopic.apply(this, arguments);
}

function _createTopic() {
  _createTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(contentType, title, content, authorId, featuredImage, featuredImageAltText, tags, sticky, closed, productAreas, publicLabel, categoryId, poll, bugStatusId) {
    var parameters, url;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            parameters = _qs.default.stringify({
              authorId: authorId
            }, {
              addQueryPrefix: true
            });
            url = createContentEndpoint(contentType);
            _context3.next = 4;
            return _axios.default.post("".concat(url).concat(parameters), _objectSpread({
              title: title,
              content: content,
              featuredImage: featuredImage,
              featuredImageAltText: featuredImageAltText,
              tags: tags,
              sticky: sticky,
              closed: closed,
              productAreas: productAreas,
              publicLabel: publicLabel,
              categoryId: categoryId,
              poll: poll
            }, bugStatusId && {
              bugStatusId: bugStatusId
            }));

          case 4:
            return _context3.abrupt("return", _context3.sent);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _createTopic.apply(this, arguments);
}

function publish(_x17, _x18) {
  return _publish.apply(this, arguments);
}

function _publish() {
  _publish = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(contentType, privateId) {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/publish"));

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _publish.apply(this, arguments);
}

function getTopic(_x19, _x20) {
  return _getTopic.apply(this, arguments);
}

function _getTopic() {
  _getTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(contentType, privateId) {
    var _yield$axios$get, data;

    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _axios.default.get("/community/api/".concat(contentType, "s/").concat(privateId));

          case 2:
            _yield$axios$get = _context5.sent;
            data = _yield$axios$get.data;
            return _context5.abrupt("return", data);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getTopic.apply(this, arguments);
}

function getReplies(_x21, _x22, _x23, _x24, _x25) {
  return _getReplies.apply(this, arguments);
}

function _getReplies() {
  _getReplies = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(contentType, privateId, page, pageSize, sort) {
    var parameters, _yield$axios$get2, data;

    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            parameters = _qs.default.stringify({
              page: page,
              pageSize: pageSize,
              sort: sort
            }, {
              addQueryPrefix: true
            });
            _context6.next = 3;
            return _axios.default.get("/community/api/".concat(contentType, "s/").concat(privateId, "/replies").concat(parameters));

          case 3:
            _yield$axios$get2 = _context6.sent;
            data = _yield$axios$get2.data;
            return _context6.abrupt("return", data);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getReplies.apply(this, arguments);
}

function replyToTopic(_x26, _x27, _x28, _x29) {
  return _replyToTopic.apply(this, arguments);
}

function _replyToTopic() {
  _replyToTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(contentType, privateId, content, parentId) {
    var payload;
    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            payload = {
              content: content
            };

            if (typeof parentId === 'number' && !Number.isNaN(parentId)) {
              payload.parentId = parentId;
            }

            _context7.next = 4;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/reply"), payload);

          case 4:
            return _context7.abrupt("return", _context7.sent);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _replyToTopic.apply(this, arguments);
}

function like(_x30, _x31, _x32) {
  return _like.apply(this, arguments);
}

function _like() {
  _like = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(contentType, privateId, likedBy) {
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/like"), {
              likedBy: likedBy
            });

          case 2:
            return _context8.abrupt("return", _context8.sent);

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _like.apply(this, arguments);
}

function unlike(_x33, _x34, _x35) {
  return _unlike.apply(this, arguments);
}

function _unlike() {
  _unlike = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(contentType, privateId, unlikedBy) {
    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/unlike"), {
              unlikedBy: unlikedBy
            });

          case 2:
            return _context9.abrupt("return", _context9.sent);

          case 3:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _unlike.apply(this, arguments);
}

function likeReply(_x36, _x37, _x38) {
  return _likeReply.apply(this, arguments);
}

function _likeReply() {
  _likeReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(contentType, replyId, likedBy) {
    return _regenerator.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/like"), {
              likedBy: likedBy
            });

          case 2:
            return _context10.abrupt("return", _context10.sent);

          case 3:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _likeReply.apply(this, arguments);
}

function unlikeReply(_x39, _x40, _x41) {
  return _unlikeReply.apply(this, arguments);
}

function _unlikeReply() {
  _unlikeReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(contentType, replyId, unlikedBy) {
    return _regenerator.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/unlike"), {
              unlikedBy: unlikedBy
            });

          case 2:
            return _context11.abrupt("return", _context11.sent);

          case 3:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _unlikeReply.apply(this, arguments);
}

function vote(_x42, _x43, _x44) {
  return _vote.apply(this, arguments);
}

function _vote() {
  _vote = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(contentType, privateId, votedBy) {
    return _regenerator.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/vote"), {
              votedBy: votedBy
            });

          case 2:
            return _context12.abrupt("return", _context12.sent);

          case 3:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _vote.apply(this, arguments);
}

function unvote(_x45, _x46, _x47) {
  return _unvote.apply(this, arguments);
}

function _unvote() {
  _unvote = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(contentType, privateId, unvotedBy) {
    return _regenerator.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/unvote"), {
              unvotedBy: unvotedBy
            });

          case 2:
            return _context13.abrupt("return", _context13.sent);

          case 3:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _unvote.apply(this, arguments);
}

function mergeVotes(_x48, _x49, _x50) {
  return _mergeVotes.apply(this, arguments);
}

function _mergeVotes() {
  _mergeVotes = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(contentType, fromPrivateId, toPrivateId) {
    return _regenerator.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(fromPrivateId, "/mergeVotes"), {
              toIdeaId: toPrivateId
            });

          case 2:
            return _context14.abrupt("return", _context14.sent);

          case 3:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _mergeVotes.apply(this, arguments);
}

function assignIdeaStatus(_x51, _x52, _x53) {
  return _assignIdeaStatus.apply(this, arguments);
}

function _assignIdeaStatus() {
  _assignIdeaStatus = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(contentType, privateId, ideaStatusId) {
    return _regenerator.default.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/assignIdeaStatus"), {
              ideaStatusId: ideaStatusId
            });

          case 2:
            return _context15.abrupt("return", _context15.sent);

          case 3:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _assignIdeaStatus.apply(this, arguments);
}

function assignModerator(_x54, _x55, _x56) {
  return _assignModerator.apply(this, arguments);
}

function _assignModerator() {
  _assignModerator = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(contentType, privateIds, moderatorId) {
    return _regenerator.default.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/assignModerator"), {
              ideaIds: privateIds,
              assignedTo: moderatorId
            });

          case 2:
            return _context16.abrupt("return", _context16.sent);

          case 3:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _assignModerator.apply(this, arguments);
}

function unassignModerator(_x57, _x58) {
  return _unassignModerator.apply(this, arguments);
}

function _unassignModerator() {
  _unassignModerator = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(contentType, privateIds) {
    return _regenerator.default.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/unassignModerator"), {
              ideaIds: privateIds
            });

          case 2:
            return _context17.abrupt("return", _context17.sent);

          case 3:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _unassignModerator.apply(this, arguments);
}

function editTitle(_x59, _x60, _x61) {
  return _editTitle.apply(this, arguments);
}

function _editTitle() {
  _editTitle = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(contentType, privateId, title) {
    return _regenerator.default.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editTitle"), {
              title: title
            });

          case 2:
            return _context18.abrupt("return", _context18.sent);

          case 3:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _editTitle.apply(this, arguments);
}

function editContent(_x62, _x63, _x64) {
  return _editContent.apply(this, arguments);
}

function _editContent() {
  _editContent = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(contentType, privateId, content) {
    return _regenerator.default.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editContent"), {
              content: content
            });

          case 2:
            return _context19.abrupt("return", _context19.sent);

          case 3:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _editContent.apply(this, arguments);
}

function editPollTitle(_x65, _x66, _x67) {
  return _editPollTitle.apply(this, arguments);
}

function _editPollTitle() {
  _editPollTitle = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(contentType, privateId, title) {
    return _regenerator.default.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editPollTitle"), {
              title: title
            });

          case 2:
            return _context20.abrupt("return", _context20.sent);

          case 3:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _editPollTitle.apply(this, arguments);
}

function editPollOptions(_x68, _x69, _x70) {
  return _editPollOptions.apply(this, arguments);
}

function _editPollOptions() {
  _editPollOptions = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21(contentType, privateId, options) {
    return _regenerator.default.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editPollOptions"), {
              options: options
            });

          case 2:
            return _context21.abrupt("return", _context21.sent);

          case 3:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _editPollOptions.apply(this, arguments);
}

function editReply(_x71, _x72, _x73) {
  return _editReply.apply(this, arguments);
}

function _editReply() {
  _editReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22(contentType, replyId, content) {
    return _regenerator.default.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/editContent"), {
              content: content
            });

          case 2:
            return _context22.abrupt("return", _context22.sent);

          case 3:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _editReply.apply(this, arguments);
}

function deletePoll(_x74, _x75) {
  return _deletePoll.apply(this, arguments);
}

function _deletePoll() {
  _deletePoll = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(contentType, privateId) {
    return _regenerator.default.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.next = 2;
            return _axios.default.delete("/community/api/".concat(contentType, "s/").concat(privateId, "/poll"), {
              data: {
                csrfToken: (0, _csrfToken.csrfToken)()
              }
            });

          case 2:
            return _context23.abrupt("return", _context23.sent);

          case 3:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _deletePoll.apply(this, arguments);
}

function editPublicLabel(_x76, _x77, _x78) {
  return _editPublicLabel.apply(this, arguments);
}

function _editPublicLabel() {
  _editPublicLabel = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee24(contentType, privateId, publicLabel) {
    return _regenerator.default.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _context24.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editPublicLabel"), {
              publicLabel: publicLabel
            });

          case 2:
            return _context24.abrupt("return", _context24.sent);

          case 3:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
  return _editPublicLabel.apply(this, arguments);
}

function editTags(_x79, _x80, _x81) {
  return _editTags.apply(this, arguments);
}

function _editTags() {
  _editTags = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee25(contentType, privateId, tags) {
    return _regenerator.default.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            _context25.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editTags"), {
              tags: tags
            });

          case 2:
            return _context25.abrupt("return", _context25.sent);

          case 3:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));
  return _editTags.apply(this, arguments);
}

function editModeratorTags(_x82, _x83, _x84) {
  return _editModeratorTags.apply(this, arguments);
}

function _editModeratorTags() {
  _editModeratorTags = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee26(contentType, privateId, moderatorTags) {
    return _regenerator.default.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            _context26.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editModeratorTags"), {
              moderatorTags: moderatorTags
            });

          case 2:
            return _context26.abrupt("return", _context26.sent);

          case 3:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));
  return _editModeratorTags.apply(this, arguments);
}

function editFeaturedImage(_x85, _x86, _x87) {
  return _editFeaturedImage.apply(this, arguments);
}

function _editFeaturedImage() {
  _editFeaturedImage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee27(contentType, privateId, featuredImage) {
    return _regenerator.default.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            _context27.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editFeaturedImage"), {
              featuredImage: featuredImage
            });

          case 2:
            return _context27.abrupt("return", _context27.sent);

          case 3:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));
  return _editFeaturedImage.apply(this, arguments);
}

function editFeaturedImageAltText(_x88, _x89, _x90) {
  return _editFeaturedImageAltText.apply(this, arguments);
}

function _editFeaturedImageAltText() {
  _editFeaturedImageAltText = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee28(contentType, privateId, featuredImageAltText) {
    return _regenerator.default.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            _context28.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editFeaturedImageAltText"), {
              featuredImageAltText: featuredImageAltText
            });

          case 2:
            return _context28.abrupt("return", _context28.sent);

          case 3:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }));
  return _editFeaturedImageAltText.apply(this, arguments);
}

function editProductAreas(_x91, _x92, _x93) {
  return _editProductAreas.apply(this, arguments);
}

function _editProductAreas() {
  _editProductAreas = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee29(contentType, privateId, productAreas) {
    return _regenerator.default.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            _context29.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/editProductAreas"), {
              productAreas: productAreas
            });

          case 2:
            return _context29.abrupt("return", _context29.sent);

          case 3:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29);
  }));
  return _editProductAreas.apply(this, arguments);
}

function changeAuthor(_x94, _x95, _x96) {
  return _changeAuthor.apply(this, arguments);
}

function _changeAuthor() {
  _changeAuthor = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee30(contentType, privateId, authorId) {
    return _regenerator.default.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            _context30.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/changeAuthor"), {
              authorId: authorId
            });

          case 2:
            return _context30.abrupt("return", _context30.sent);

          case 3:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30);
  }));
  return _changeAuthor.apply(this, arguments);
}

function toggleClosed(_x97, _x98, _x99) {
  return _toggleClosed.apply(this, arguments);
}

function _toggleClosed() {
  _toggleClosed = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee31(contentType, privateId, closed) {
    return _regenerator.default.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            _context31.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/toggleClosed"), {
              closed: closed
            });

          case 2:
            return _context31.abrupt("return", _context31.sent);

          case 3:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31);
  }));
  return _toggleClosed.apply(this, arguments);
}

function toggleSticky(_x100, _x101, _x102) {
  return _toggleSticky.apply(this, arguments);
}

function _toggleSticky() {
  _toggleSticky = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee32(contentType, privateId, sticky) {
    return _regenerator.default.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            _context32.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/toggleStickyState"), {
              sticky: sticky
            });

          case 2:
            return _context32.abrupt("return", _context32.sent);

          case 3:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32);
  }));
  return _toggleSticky.apply(this, arguments);
}

function toggleTrashed(_x103, _x104, _x105) {
  return _toggleTrashed.apply(this, arguments);
}

function _toggleTrashed() {
  _toggleTrashed = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee33(contentType, privateId, trashed) {
    return _regenerator.default.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            _context33.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/toggleTrashed"), {
              trashed: trashed
            });

          case 2:
            return _context33.abrupt("return", _context33.sent);

          case 3:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33);
  }));
  return _toggleTrashed.apply(this, arguments);
}

function toggleReplyTrashed(_x106, _x107, _x108) {
  return _toggleReplyTrashed.apply(this, arguments);
}

function _toggleReplyTrashed() {
  _toggleReplyTrashed = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee34(contentType, replyId, trashed) {
    return _regenerator.default.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            _context34.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/toggleTrashed"), {
              trashed: trashed
            });

          case 2:
            return _context34.abrupt("return", _context34.sent);

          case 3:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34);
  }));
  return _toggleReplyTrashed.apply(this, arguments);
}

function move(_x109, _x110, _x111) {
  return _move.apply(this, arguments);
}

function _move() {
  _move = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee35(contentType, privateId, categoryId) {
    return _regenerator.default.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            _context35.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/move"), {
              categoryId: categoryId
            });

          case 2:
            return _context35.abrupt("return", _context35.sent);

          case 3:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35);
  }));
  return _move.apply(this, arguments);
}

function schedule(_x112, _x113, _x114) {
  return _schedule.apply(this, arguments);
}

function _schedule() {
  _schedule = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee36(contentType, privateId, scheduleDate) {
    return _regenerator.default.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            _context36.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/schedule"), {
              scheduleDate: scheduleDate
            });

          case 2:
            return _context36.abrupt("return", _context36.sent);

          case 3:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36);
  }));
  return _schedule.apply(this, arguments);
}

function cancelSchedule(_x115, _x116) {
  return _cancelSchedule.apply(this, arguments);
}

function _cancelSchedule() {
  _cancelSchedule = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee37(contentType, privateId) {
    return _regenerator.default.wrap(function _callee37$(_context37) {
      while (1) {
        switch (_context37.prev = _context37.next) {
          case 0:
            _context37.next = 2;
            return _axios.default.delete("/community/api/".concat(contentType, "s/").concat(privateId, "/schedule"), {
              data: {
                csrfToken: (0, _csrfToken.csrfToken)()
              }
            });

          case 2:
            return _context37.abrupt("return", _context37.sent);

          case 3:
          case "end":
            return _context37.stop();
        }
      }
    }, _callee37);
  }));
  return _cancelSchedule.apply(this, arguments);
}

function deleteTopic(_x117, _x118) {
  return _deleteTopic.apply(this, arguments);
}

function _deleteTopic() {
  _deleteTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee38(contentType, privateId) {
    return _regenerator.default.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            _context38.next = 2;
            return _axios.default.delete("/community/api/".concat(contentType, "s/").concat(privateId), {
              data: {
                csrfToken: (0, _csrfToken.csrfToken)()
              }
            });

          case 2:
            return _context38.abrupt("return", _context38.sent);

          case 3:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38);
  }));
  return _deleteTopic.apply(this, arguments);
}

function setModerationLabel(_x119, _x120, _x121) {
  return _setModerationLabel.apply(this, arguments);
}

function _setModerationLabel() {
  _setModerationLabel = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee39(contentType, privateIds, moderationLabelId) {
    var _axios$post;

    return _regenerator.default.wrap(function _callee39$(_context39) {
      while (1) {
        switch (_context39.prev = _context39.next) {
          case 0:
            _context39.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/setModerationLabel"), (_axios$post = {}, (0, _defineProperty2.default)(_axios$post, "".concat(contentType, "Ids"), privateIds), (0, _defineProperty2.default)(_axios$post, "moderationLabelId", moderationLabelId), _axios$post));

          case 2:
            return _context39.abrupt("return", _context39.sent);

          case 3:
          case "end":
            return _context39.stop();
        }
      }
    }, _callee39);
  }));
  return _setModerationLabel.apply(this, arguments);
}

function unsetModerationLabel(_x122, _x123) {
  return _unsetModerationLabel.apply(this, arguments);
}

function _unsetModerationLabel() {
  _unsetModerationLabel = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee40(contentType, privateIds) {
    return _regenerator.default.wrap(function _callee40$(_context40) {
      while (1) {
        switch (_context40.prev = _context40.next) {
          case 0:
            _context40.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/unsetModerationLabel"), (0, _defineProperty2.default)({}, "".concat(contentType, "Ids"), privateIds));

          case 2:
            return _context40.abrupt("return", _context40.sent);

          case 3:
          case "end":
            return _context40.stop();
        }
      }
    }, _callee40);
  }));
  return _unsetModerationLabel.apply(this, arguments);
}

function approveTopic(_x124, _x125) {
  return _approveTopic.apply(this, arguments);
}

function _approveTopic() {
  _approveTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee41(contentType, privateId) {
    return _regenerator.default.wrap(function _callee41$(_context41) {
      while (1) {
        switch (_context41.prev = _context41.next) {
          case 0:
            _context41.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/approve"));

          case 2:
            return _context41.abrupt("return", _context41.sent);

          case 3:
          case "end":
            return _context41.stop();
        }
      }
    }, _callee41);
  }));
  return _approveTopic.apply(this, arguments);
}

function approveReply(_x126, _x127) {
  return _approveReply.apply(this, arguments);
}

function _approveReply() {
  _approveReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee42(contentType, replyId) {
    return _regenerator.default.wrap(function _callee42$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            _context42.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/approve"));

          case 2:
            return _context42.abrupt("return", _context42.sent);

          case 3:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee42);
  }));
  return _approveReply.apply(this, arguments);
}

function getPrivateId(_x128) {
  return _getPrivateId.apply(this, arguments);
}

function _getPrivateId() {
  _getPrivateId = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee43(publicId) {
    var _yield$axios$get3, privateId;

    return _regenerator.default.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            _context43.next = 2;
            return _axios.default.get("/topic/privateId/".concat(publicId));

          case 2:
            _yield$axios$get3 = _context43.sent;
            privateId = _yield$axios$get3.data.privateId;
            return _context43.abrupt("return", privateId);

          case 5:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43);
  }));
  return _getPrivateId.apply(this, arguments);
}

function getContentType(_x129) {
  return _getContentType.apply(this, arguments);
}

function _getContentType() {
  _getContentType = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee44(publicId) {
    var _yield$axios$get4, contentType;

    return _regenerator.default.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            _context44.next = 2;
            return _axios.default.get("/topic/contentType?publicId=".concat(publicId));

          case 2:
            _yield$axios$get4 = _context44.sent;
            contentType = _yield$axios$get4.data.contentType;
            return _context44.abrupt("return", contentType);

          case 5:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44);
  }));
  return _getContentType.apply(this, arguments);
}

function isTopicAvailable(_x130, _x131) {
  return _isTopicAvailable.apply(this, arguments);
}

function _isTopicAvailable() {
  _isTopicAvailable = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee45(privateId, contentType) {
    var _yield$axios$get5, isTopicAvailable;

    return _regenerator.default.wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            _context45.next = 2;
            return _axios.default.get("/topic/isTopicAvailable?privateId=".concat(privateId, "&contentType=").concat(contentType));

          case 2:
            _yield$axios$get5 = _context45.sent;
            isTopicAvailable = _yield$axios$get5.data.isTopicAvailable;
            return _context45.abrupt("return", isTopicAvailable);

          case 5:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45);
  }));
  return _isTopicAvailable.apply(this, arguments);
}

function markTopicAsSpam(_x132, _x133) {
  return _markTopicAsSpam.apply(this, arguments);
}

function _markTopicAsSpam() {
  _markTopicAsSpam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee46(contentType, topicId) {
    return _regenerator.default.wrap(function _callee46$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            _context46.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(topicId, "/markAsSpam"));

          case 2:
            return _context46.abrupt("return", _context46.sent);

          case 3:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee46);
  }));
  return _markTopicAsSpam.apply(this, arguments);
}

function highlightReply(_x134, _x135, _x136) {
  return _highlightReply.apply(this, arguments);
}

function _highlightReply() {
  _highlightReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee47(contentType, replyId, highlighted) {
    return _regenerator.default.wrap(function _callee47$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            _context47.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/toggleHighlight"), {
              highlighted: highlighted
            });

          case 2:
            return _context47.abrupt("return", _context47.sent);

          case 3:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee47);
  }));
  return _highlightReply.apply(this, arguments);
}

function resolveTopic(_x137, _x138) {
  return _resolveTopic.apply(this, arguments);
}

function _resolveTopic() {
  _resolveTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee48(contentType, privateId) {
    var userId;
    return _regenerator.default.wrap(function _callee48$(_context48) {
      while (1) {
        switch (_context48.prev = _context48.next) {
          case 0:
            userId = (0, _insidedDataStorage.getInsidedData)('user').userid;
            _context48.next = 3;
            return _axios.default.post("/community/api/".concat(contentType, "s/").concat(privateId, "/resolve?resolvedBy=").concat(userId));

          case 3:
            return _context48.abrupt("return", _context48.sent);

          case 4:
          case "end":
            return _context48.stop();
        }
      }
    }, _callee48);
  }));
  return _resolveTopic.apply(this, arguments);
}

function resolveReply(_x139, _x140) {
  return _resolveReply.apply(this, arguments);
}

function _resolveReply() {
  _resolveReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee49(contentType, replyId) {
    var userId;
    return _regenerator.default.wrap(function _callee49$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            userId = (0, _insidedDataStorage.getInsidedData)('user').userid;
            _context49.next = 3;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/resolve?resolvedBy=").concat(userId));

          case 3:
            return _context49.abrupt("return", _context49.sent);

          case 4:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee49);
  }));
  return _resolveReply.apply(this, arguments);
}

function promoteReply(_x141, _x142, _x143, _x144) {
  return _promoteReply.apply(this, arguments);
}

function _promoteReply() {
  _promoteReply = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee50(contentType, replyId, title, categoryId) {
    var _response$headers$loc;

    var response, location;
    return _regenerator.default.wrap(function _callee50$(_context50) {
      while (1) {
        switch (_context50.prev = _context50.next) {
          case 0:
            _context50.next = 2;
            return _axios.default.post("/community/api/".concat(contentType, "s/replies/").concat(replyId, "/promote"), {
              title: title,
              categoryId: categoryId
            });

          case 2:
            response = _context50.sent;
            location = (_response$headers$loc = response.headers.location) !== null && _response$headers$loc !== void 0 ? _response$headers$loc : '';
            return _context50.abrupt("return", Number(location.split('/')[3]));

          case 5:
          case "end":
            return _context50.stop();
        }
      }
    }, _callee50);
  }));
  return _promoteReply.apply(this, arguments);
}